import React, { useState, useEffect } from 'react';
import '../../../../styles/sass/clients/clientTabs.scss';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { Card, CardBody, VectorSVG, UnlockSVG, LockClientSVG } from '../../../../components';
import ClientsDeleteDialog from '../../list/ClientsDeleteDialog';
import ClientData from './ClientData';
import { useTranslation } from 'react-i18next';

export default function ClientTabs ({ data, clientId, sendPin, setShowBlockUserDialog, setShowRecoverPassDialog, setActionModal, client, isDischarged, setAlert, setOpenAlert, isLoading, error }) {
    const { t } = useTranslation();
    // State
    // Dialogs state
    const [dialog, setDialog] = useState(false);
    const [showDeleteClient, setShowDeleteClient] = useState(true);
    // Functions
    const handleClickClientDelete = () => {
        setDialog(true);
    };
    useEffect(() => {
        setShowDeleteClient(!isDischarged);
    // eslint-disable-next-line
    },[isDischarged])
    // Main component

    return (
        <Card className='h-10'>
            <CardBody className='h-100'>
                {error && (<Typography sx={{ color: 'red', textAlign: 'center' }}>{t('errors.notFound')}</Typography>)}
                {(isLoading || !data) && (<Stack alignItems={'center'}><CircularProgress size={24} style={{ color: 'primary' }} /></Stack>)}
                {(data?.status && !isLoading) && (
                    <>
                        <ClientsDeleteDialog
                            open={dialog}
                            client={client}
                            onClose={() => {
                                setDialog(null);
                            }}
                            onDelete={() => { setShowDeleteClient(false); }}
                            setAlert={setAlert}
                            setOpenAlert={setOpenAlert}
                        />
                        <Box
                            display='flex'
                            flexDirection='row'
                            justifyContent='space-between'
                            margin='0 10px 8px 0'>
                            <Box display='flex' flexDirection='row' alignItems='flex-start'>
                                <Link className="client" to={'/clients'} sx={{ color: 'red !important' }}>
                                    {t('clients.title')}
                                </Link>
                                <span className='vector'><VectorSVG /></span>
                                <span className='clientId'>ID {clientId}</span>
                            </Box>
                            {data.status !== 'inactive' && (
                                <Box display='flex' flexDirection='row' >
                                    {data.status !== 'blocked' && (
                                        <Button
                                            className='buttonAction button-action--block'
                                            onClick={() => { setShowBlockUserDialog(true); setActionModal('blockUser'); }}
                                            endIcon={<LockClientSVG color="white" />}
                                        >{t('buttons.block')}
                                        </Button>
                                    )}
                                    {data.status === 'blocked' && (
                                        <Button
                                            className='buttonAction button-action--unblock'
                                            onClick={() => { sendPin(clientId); setActionModal('sendPin'); }}
                                            endIcon={<UnlockSVG />}
                                        >{t('buttons.unblock')}
                                        </Button>
                                    )}
                                    <Button
                                        className='buttonAction button-action--recover-password'
                                        onClick={() => { setShowRecoverPassDialog(true); setActionModal('recoverPass'); }}
                                    >{t('buttons.recoverPassword')}
                                    </Button>
                                    { (showDeleteClient) && <Button
                                        className='buttonAction button-action--unsubscribe'
                                        onClick={() => handleClickClientDelete()}
                                    >{t('buttons.unsubscribe')}
                                    </Button>}
                                </Box>)}
                        </Box>
                        <ClientData data={data} client={client} />
                    </>
                )}
            </CardBody>
        </Card >
    );
}
